export class CheckType {

    static checkDate(toCheck: any): boolean {
        return (toCheck != null && toCheck instanceof Date && !isNaN(toCheck.getTime()));
    }

    static getDateFormat(str: any): string {

        let format = 'DDMMYYYY';

        if (str instanceof String && str.match('\/')) {
            format = 'DD/MM/YYYY';
        }
        return format;
    }
}
